import abstractModel from '../../core/MercatelyModel';
import { serializeParams } from '../../util/urlUtils';

const csrfToken = document.querySelector('[name=csrf-token]').content;
const resource = '/api/mia/chatbot/retailer_auth_methods';

const model = abstractModel(resource);
const parentGet = model.get;
const parentSave = model.save;
const parentPut = model.put;
const parentDelete = model.remove;

model.get = (params = {}) => {
  if (params && typeof params === 'object' && !Array.isArray(params)) {
    const hasArrayParams = Object.values(params).some((value) => Array.isArray(value));

    if (hasArrayParams) {
      const queryString = serializeParams(params);
      return parentGet({}, { path: resource, filters: queryString });
    }
  }

  return parentGet(params, { path: resource });
};

model.retrieve = (authMethodId) => parentGet({}, { path: `${resource}/${authMethodId}` });

model.save = (data) => parentSave(data, { path: resource, csrfToken });

model.update = (authMethodId, data) => parentPut(data, { path: `${resource}/${authMethodId}`, csrfToken });

model.delete = (authMethodId) => parentDelete({ id: authMethodId }, { path: resource, csrfToken });

export default model;
